var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2554 2.45154C22.4834 4.05944 24.4025 6.39079 25.8582 9.22332L26 9.5L25.8582 9.77441C24.4025 12.6069 22.4813 14.9383 20.2554 16.5462C18.0824 18.1155 15.6152 19 13 19C10.3848 19 7.91764 18.1155 5.74675 16.5485C3.5166 14.9383 1.59749 12.6069 0.141764 9.77441L0 9.5L0.141764 9.22332C1.59749 6.39079 3.5166 4.05944 5.74463 2.45154C7.91764 0.884459 10.3848 0 13 0C15.6152 0 18.0802 0.884459 20.2554 2.45154ZM12.8625 5.02781L13.7257 5.11626C13.4189 5.61065 13.237 6.20936 13.237 6.85569C13.237 8.55204 14.4769 9.92636 16.0088 9.92636C16.4997 9.92636 16.9609 9.78575 17.3608 9.53629C17.3672 9.64287 17.3714 9.74946 17.3714 9.85832C17.3714 12.5276 15.3529 14.6911 12.8625 14.6911C10.3721 14.6911 8.35352 12.5276 8.35352 9.85832C8.35352 7.19133 10.3721 5.02781 12.8625 5.02781ZM23.0632 9.5C21.8994 7.30926 20.395 5.50859 18.6642 4.25901C16.9609 3.02984 15.0355 2.33588 13 2.33588C10.9666 2.33588 9.04118 3.02984 7.33789 4.25901C5.6071 5.50859 4.1027 7.30926 2.93685 9.5C4.10059 11.6907 5.6071 13.4914 7.33789 14.7387C9.04118 15.9679 10.9666 16.6619 13 16.6619C15.0355 16.6619 16.9588 15.9679 18.6642 14.7387C20.395 13.4914 21.8994 11.6907 23.0632 9.5Z",
    fill: "#707683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.88a7cea9523244e056385dfda59c9dbb.svg";
export { ForwardRef as ReactComponent };